import { useEffect, useRef } from 'react';
import api from '../api/axios';
import notificationSound from '../utils/notificationSound';

export default function GlobalNotificationMonitor() {
  const lastCheckTime = useRef(null);
  const previousUnreadCount = useRef(0);
  const isInitialized = useRef(false);

  const checkForNewNotifications = async () => {
    try {
      const res = await api.get('/notifications');
      const notificationsData = res.data?.data || res.data || [];
      const adminNotifications = notificationsData.filter(n => n.user_id === null);
      const unreadNotifications = adminNotifications.filter(n => !n.is_read);
      const currentUnreadCount = unreadNotifications.length;
      
      // Initialize on first load
      if (!isInitialized.current) {
        previousUnreadCount.current = currentUnreadCount;
        lastCheckTime.current = new Date();
        isInitialized.current = true;
        return;
      }
      
      // Check if there are new unread notifications
      if (currentUnreadCount > previousUnreadCount.current) {
        // Check if latest notification is actually new (created after last check)
        if (unreadNotifications.length > 0) {
          const latestNotification = unreadNotifications[0];
          const notificationTime = new Date(latestNotification.created_at);
          
          if (notificationTime > lastCheckTime.current) {
            // Play notification sound
            notificationSound.playBookingNotification();
            console.log('New booking notification:', latestNotification);
          }
        }
      }
      
      previousUnreadCount.current = currentUnreadCount;
      lastCheckTime.current = new Date();
    } catch (error) {
      if (error.code !== 'ECONNABORTED' && error.message !== 'Network Error') {
        console.error('Error checking notifications:', error.message);
      }
    }
  };

  useEffect(() => {
    // Initial check
    checkForNewNotifications();
    
    // Set up interval to check every 10 seconds
    const interval = setInterval(checkForNewNotifications, 10000);
    
    return () => clearInterval(interval);
  }, []);

  // This component doesn't render anything
  return null;
}